// extracted by mini-css-extract-plugin
module.exports = {"tabs":"AdGroupSelectionSlide_tabs__eF8rM","loaderLabel":"AdGroupSelectionSlide_loaderLabel__3AdwB"};